import * as types from '../actions/preferences/types';


const INITIAL_STATE = {};

export default function accountReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.ACCOUNT_PREFERENCES:

      return action.payload;

    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js